import styled from 'styled-components';
import BaseGrid from '@klv/utils/grid';

import type { TColorVariant } from '@klv/shared/styles/types';

export const IframeModule = styled.section<{ $backgroundColor: TColorVariant; }>`
  width: 100%;
  margin: 0 auto;

  ${({ theme, $backgroundColor }) => `
    ${theme.globalPadding};
    background-color: ${theme.iframe[$backgroundColor].backgroundColor};
  `}
`;

export const IframeGrid = styled(BaseGrid)`
  grid-template-columns: 1fr;
  grid-template-areas: 'col1';
`;

export const StyledIframe = styled.iframe<{ $height: string; }>`
  width: 100%;
  height: ${({ $height }) => $height};
  padding-bottom: 0.8rem; // Just to prevent the iframe scrollbar from blocking the resize button
  resize: vertical;
  border: 0;
`;
